<template>
  <main class="main">
    <form class="form" @submit.prevent="createUpdateProduit">
      <fieldset class="fieldset">
        <legend class="legend">
          <PhFunnel />
          <span>Informations</span>
        </legend>

        <div class="field">
          <label class="label">Nom</label>
          <input type="text" class="input" v-model="produit.nom" required />
        </div>

        <div class="field">
          <label class="label">Catégorie</label>
          <select class="select" v-model="produit.categorie_produit_filtration" required>
            <option v-for="categorie in categories" :key="categorie.id" :value="categorie.id">
              {{ categorie.nom }}
            </option>
          </select>
        </div>
      </fieldset>
      <div class="buttons">
        <ButtonElement
          type="submit"
          color="bordeaux"
          :icon="PhFloppyDisk"
          :disabled="!cacheStore.online"
        >
          {{ produitId ? 'Modifier' : 'Créer' }}
        </ButtonElement>
      </div>
    </form>
  </main>
</template>

<script setup lang="ts">
import { PhFloppyDisk, PhFunnel } from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'
import { computed, type ComputedRef, onMounted, ref, type Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import useFetch from '@/composables/useFetch.ts'
import { useLoadingStore } from '@/stores/loading.ts'
import { useToastStore } from '@/stores/toast.ts'
import type {
  ProduitFiltrationCategorie,
  ProduitFiltrationCreate,
  ProduitFiltrationUpdate,
} from '@/interfaces/ProduitFiltrationList.ts'
import { useCacheStore } from '@/stores/cache.ts'

// dépendances
const api = useFetch()
const route = useRoute()
const router = useRouter()

// stores
const cacheStore = useCacheStore()
const loadingStore = useLoadingStore()
const toastStore = useToastStore()

// données
const produit: Ref<ProduitFiltrationCreate | ProduitFiltrationUpdate> = ref({
  id: '',
  nom: '',
  categorie_produit_filtration: '',
})
const categories: Ref<ProduitFiltrationCategorie[]> = ref([])

// computed
const produitId: ComputedRef<string | undefined> = computed(() => route.params.id?.toString())

// fonctions
async function getCategories() {
  categories.value = await cacheStore.getProduitsCategories()
}

async function getProduit() {
  if (produitId.value) produit.value = await cacheStore.getProduit(produitId.value)
}

async function createUpdateProduit() {
  loadingStore.start()
  try {
    if (produitId.value) {
      await api.put(`produits-filtration/${produitId.value}`, produit.value)
    } else {
      await api.post('produits-filtration/', produit.value)
    }
    toastStore.success(
      `Le produit de filtration a bien été ${produitId.value ? 'modifié' : 'créé'}.`,
    )
    await router.push({ name: 'produits-filtration' })
  } finally {
    loadingStore.stop()
  }
}

onMounted(async () => {
  loadingStore.start()
  try {
    await getCategories()
    await getProduit()
  } finally {
    loadingStore.stop()
  }
})
</script>
